import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';

import { TradeApplicationContainerLazy } from '../application/TradeApplicationContainerLazy';

import '../shared/TradeAppContainer.scss';
import '../application/application.scss';

const locale = serverVars.get('locale');
const messages = serverVars.get('messages');
const root = createRoot(document.getElementById('tradeApp') as HTMLElement);

initializeDBL().then(() => {
    root.render(
        <IntlProvider locale={locale} messages={messages}>
            <TradeApplicationContainerLazy />
        </IntlProvider>
    );
});
